import * as React from 'react'
import { motion, Transition, Variants } from 'framer-motion'
import { twMerge } from 'tailwind-merge'
import { Dialog } from '@highlight/ui'

interface ModalBackdropProps extends React.ComponentProps<typeof Dialog.Backdrop> {
  className?: string
}

const backdropVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}
const backdropTransition: Transition = { duration: 0.15, ease: 'easeOut' }

export function ModalBackdrop({ className, ...props }: ModalBackdropProps) {
  return (
    <Dialog.Backdrop
      render={
        <motion.div
          variants={backdropVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={backdropTransition}
        />
      }
      className={twMerge(
        // Remove CSS transitions from base UI
        '[transition:none]',
        className,
      )}
      {...props}
    />
  )
}
